import { get } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { Button, Card, Icon } from "semantic-ui-react";
import styled from "styled-components";

const UserData = ({ onSignOut, user }) => (
	<UserCard>
		<Card.Content>
			<Card.Header>{get(user, "userName")}</Card.Header>
			<Card.Meta>{get(user, "email")}</Card.Meta>
			<Card.Description>{`${get(user, "firstName")} ${get(user, "lastName")}`}</Card.Description>
		</Card.Content>
		<Card.Content>
			<Button color="orange" fluid icon labelPosition="left" onClick={onSignOut}>
				<Icon name="sign out" /> Wyloguj
			</Button>
		</Card.Content>
	</UserCard>
);

UserData.propTypes = {
	onSignOut: PropTypes.func.isRequired,
	user: PropTypes.shape({
		email: PropTypes.string.isRequired,
		firstName: PropTypes.string.isRequired,
		lastName: PropTypes.string.isRequired,
		userName: PropTypes.string.isRequired
	}).isRequired
};

const UserCard = styled(Card)`
	&& {
		box-shadow: none;
		width: 100%;
	}
`;

export { UserData };
export default UserData;



// WEBPACK FOOTER //
// ./src/components/sidebar/components/UserData.js